import React from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";

import FullPageLayout from "../../layouts/FullPage";
import BigMessage from "../../components/BigMessage";
import Button from "../../components/Button";
import { DEFAULT_PAGES } from "../../constants/global";
import { getCurrentUserRole } from "../../reducers";
import image from "./403.jpg";

const styles = (theme) => ({
  actions: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(3),
  },
});

const useStyles = makeStyles(styles);

const Forbidden = ({ from }) => {
  const role = useSelector(getCurrentUserRole);
  const redirectedFrom = from
    ? from.pathname.split("/").filter((x) => x !== "")[0]
    : "this";
  const title = `Can't access ${redirectedFrom} page.`;
  const subtitle = `You are logged in as ${role} user.`;
  const classes = useStyles();

  return (
    <FullPageLayout backgroundImage={image}>
      <BigMessage title={title} subtitle={subtitle}>
        <div className={classes.actions}>
          <Button color="primary" href={DEFAULT_PAGES[role]} size="lg">
            Dashboard
          </Button>
          <Button
            type="button"
            color="warning"
            href={`${DEFAULT_PAGES[role]}/log-out`}
            size="lg"
          >
            Log out
          </Button>
        </div>
      </BigMessage>
    </FullPageLayout>
  );
};

export default Forbidden;
